module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-SemiBold.ce96d75e.ttf";